import React from "react";

import { StyledSpinner, StyledSuspenseWrapper } from "./styledSpinner";
import MaterialCircle from "./materialCircle";

const SuspenseSpinner = () => {
  return (
    <StyledSuspenseWrapper>
      <StyledSpinner>
        <MaterialCircle />
      </StyledSpinner>
    </StyledSuspenseWrapper>
  );
};

export default SuspenseSpinner;